import { render, staticRenderFns } from "./SensorInfo.vue?vue&type=template&id=3f93e229&scoped=true&"
import script from "./SensorInfo.vue?vue&type=script&lang=ts&"
export * from "./SensorInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SensorInfo.vue?vue&type=style&index=0&id=3f93e229&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93e229",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
